import { Box, Container } from "@mui/material";
import KlarnaMark from '../general/KlarnaMark';
import { styled } from '@mui/material/styles';
import { CheckSharp } from "@mui/icons-material";
import PropTypes from "prop-types";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCustomLocaleMessage } from "../../helpers/locale";

const PREFIX = 'HeaderUspList';

const classes = {
    container: `${PREFIX}-container`,
    list: `${PREFIX}-list`,
    listItem: `${PREFIX}-listItem`,
    klarnaLogo: `${PREFIX}-klarnaLogo`
};

const StyledContainer = styled(Container)(({ theme }) => ({
    [`& .${classes.container}`]: {
		[theme.breakpoints.down('md')]: {
			display: 'none',
		},
	},

    [`& .${classes.list}`]: {
		display: 'flex',
		listStyle: 'none',
		gap: theme.spacing(1),
		alignItems: 'center',
		justifyContent: 'center',
		margin: 0,
		padding: theme.spacing(0.5, 0),
		fontSize: '0.85em',
		width: '100%',
		[theme.breakpoints.down('lg')]: {
			fontSize: '0.8em',
		},
	},

    [`& .${classes.listItem}`]: {
		display: 'flex',
        [theme.breakpoints.down('sm')]: {
            [`:not(:first-child)`]: {
                display: 'none',
            },
        },
        flexGrow: 1,
		alignItems: 'center',
        justifyContent: 'center',
		'& svg': {
			marginRight: theme.spacing(1),
			fontSize: '1.25em',
			color: theme.palette.cta.main,
		}
	},

    // Klarna-wordmerk: het officiele brandmark op een roze vlak, in de
    // merkkleuren van Klarna zelf.
    [`& .${classes.klarnaLogo}`]: {
		display: 'inline-flex',
		alignItems: 'center',
		marginRight: theme.spacing(1),
		padding: '3px 6px',
		borderRadius: '4px',
		backgroundColor: '#FFA8CD',
		color: '#0B051D',
		'& svg': {
			display: 'block',
			height: '0.8em',
			width: 'auto',
			margin: 0,
			fontSize: 'inherit',
			color: 'inherit',
		},
	}
}));

function KlarnaWordmark() {
	return (
		<Box component="span" className={classes.klarnaLogo}>
			<KlarnaMark width="3.4em" />
		</Box>
	);
}

function HeaderUspList({ items }) {
	const { i18n } = useTranslation();

	if (items.length === 0) {
		return null;
	}

	return (
        <StyledContainer>
			<ul className={classes.list}>
				{items.map((item, index) => (
					<li className={classes.listItem} key={`usp-item_${index}`}>
						{item.icon === 'klarna' ? <KlarnaWordmark /> : <CheckSharp />}
						{getCustomLocaleMessage(item.usp, i18n)}
					</li>
				))}
			</ul>
		</StyledContainer>
    );
}

HeaderUspList.propTypes = {
	items: PropTypes.arrayOf(PropTypes.shape({
		usp: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object,
		]).isRequired,
		icon: PropTypes.oneOf(['check', 'klarna']),
	})),
}

export default HeaderUspList;
